import { ListMembershipNodeData } from 'modules/workflowNodeEditors/components/ModifyListMembershipEditor';
import { CREATE_LIST_MODAL, StartNodeData } from 'modules/workflows';
import { CreateListPayload, openModal } from 'modules/workflows/ducks';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { spacing } from 'ui/theme';
import noop from 'utils/noop';

const StyledButton = styled(SecondaryButton)`
  width: ${spacing.x8};
`;

export const CREATE_LIST_BUTTON_ID = 'create-new-list-button';

export interface CreateListButtonProps {
  /** specifies if button should be disabled */
  isDisabled?: boolean;
  /** callback to update nodeData, after list creation */
  onListCreate?: (data: Partial<StartNodeData | ListMembershipNodeData>) => void;
  /** whether to show + icon */
  showIcon?: boolean;
  isMulti?: boolean;
}

export const CreateListButton = ({
  isDisabled = false,
  onListCreate = noop,
  showIcon = false,
  isMulti = false,
}: CreateListButtonProps) => {
  const dispatch = useDispatch();

  const updateListItem = (newListId: number, newListName: string) => {
    const newListData: Partial<StartNodeData | ListMembershipNodeData> = isMulti
      ? { emailListIds: [newListId] }
      : { emailListId: newListId, resource: { name: newListName } };

    onListCreate(newListData);
  };

  const handleListCreate: CreateListPayload['onListCreated'] = (list) =>
    (list?.id || list?.id === 0) && updateListItem(list.id, list.name);

  return (
    <StyledButton
      data-test={CREATE_LIST_BUTTON_ID}
      size={BUTTON_SIZES.LARGE}
      onClick={() => dispatch(openModal(CREATE_LIST_MODAL, { onListCreated: handleListCreate }))}
      isDisabled={isDisabled}
    >
      {showIcon && <Add16 />}
      Create list
    </StyledButton>
  );
};
